import angular from 'angular';

angular.module('dashboard').controller('EnvelopeContainerCtrl', [
    '$scope',
    '$uibModalInstance',
    'container',
    function($scope, $uibModalInstance, container) {
        $scope.container = container;

        $scope.close = function() {
            $uibModalInstance.dismiss();
        };
    }
]);
